// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"u8-z"};